import { render, staticRenderFns } from "./RevizorDashboardPage.vue?vue&type=template&id=4259d4da&scoped=true&"
import script from "./RevizorDashboardPage.vue?vue&type=script&lang=js&"
export * from "./RevizorDashboardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4259d4da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
